import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';

// Simple modal to request a password when exiting impersonation.

@Component({
  selector: 'app-exit-impersonation-modal',
  templateUrl: './exit-impersonation-modal.component.html',
  styleUrls: ["./exit-impersonation-modal.component.scss"]
})
export class ExitImpersonationModalComponent implements AfterViewInit {
  showNewPassword = false;
  form;
  @Output() passwordSubmit = new EventEmitter<string>();
  isSubmitting = false;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {
    this.form = this.fb.group({
      password: ['', Validators.required]
    });
  }

  ngAfterViewInit() {
  const tryBlur = () => {
    const el = document.querySelector('.modal .btn-close') as HTMLElement;
    if (el && document.activeElement === el) {
      el.blur();
    } else {
      requestAnimationFrame(tryBlur);
    }
  };
  requestAnimationFrame(tryBlur);
}


  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isSubmitting = true;
    const password = this.form.value.password ?? undefined;
    this.passwordSubmit.emit(password);
  }

  cancel() {
    this.activeModal.dismiss();
  }

  toggleNewPasswordVisibility(): void {
    this.showNewPassword = !this.showNewPassword;
  }
}
